import { TeamOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { useLeadCardContext } from '@app/components/LeadCard/context';
import { BranchSelector } from '@app/components/LeadCard/ui/BranchSelector';

import type { FC } from 'react';

import './MainHeader.scss';

export const MainHeader: FC = () => {
  const {
    isLeadListEnabled,
    openLeadListDrawer,
    openUserDetailsDrawer,
    showLeadsColumn,
    showDetailsColumn,
  } = useLeadCardContext();

  return (
    <header className="MainHeader">
      <div className="MainHeader__controls">
        {isLeadListEnabled && !showLeadsColumn && (
          <Tooltip title="Открыть список лидов">
            <Button
              className="MainHeader__button"
              icon={<TeamOutlined />}
              size="small"
              onClick={openLeadListDrawer}
              style={{ marginBottom: '3px' }}
            />
          </Tooltip>
        )}

        <BranchSelector />

        {!showDetailsColumn && (
          <Tooltip title="Открыть детали пользователя">
            <Button
              className="MainHeader__button"
              icon={<UserOutlined />}
              size="small"
              onClick={openUserDetailsDrawer}
              style={{ marginBottom: '3px' }}
            />
          </Tooltip>
        )}
      </div>
    </header>
  );
};
